import { useQuery, type QueryKey, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query'

/**
 * useAutoQuery — TanStack useQuery wrapper that auto-refetches frequently.
 *
 * Defaults:
 *   refetchInterval:        10 seconds
 *   refetchOnWindowFocus:   true
 *   staleTime:              5 seconds
 *
 * In Phase 13 (SSE), hot views switch to event-driven invalidation and
 * disable polling per-call by passing { refetchInterval: false }.
 */
export function useAutoQuery<TData, TError = Error>(
  options: UseQueryOptions<TData, TError, TData, QueryKey> & { queryKey: QueryKey; queryFn: () => Promise<TData> }
): UseQueryResult<TData, TError> {
  return useQuery<TData, TError, TData, QueryKey>({
    refetchInterval: 10_000,
    refetchOnWindowFocus: true,
    staleTime: 5_000,
    ...options,
  })
}
